module.exports = __webpack_public_path__ + "static/media/prawnik.ca39cb4a.svg";